import { render } from "./CountdownTimer.vue?vue&type=template&id=af8dbf3e&scoped=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=js"
export * from "./CountdownTimer.vue?vue&type=script&lang=js"

import "./CountdownTimer.vue?vue&type=style&index=0&id=af8dbf3e&scoped=true&lang=scss"

import exportComponent from "/web/bathroom-web2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8dbf3e"]])

export default __exports__